import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChalkboardUser, faClock, faRepeat, faUsers, faLocationDot, faStairs, faCarSide, faIndent, faCircleXmark, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { PreventableEvent } from '@progress/kendo-angular-buttons';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { startWith, filter, takeUntil, finalize, combineLatest } from 'rxjs';
import { getStudentSchoolAddressModel } from 'src/app/modules/provider-management/constants/assign-provider-request-model';
import { IProviderManagementInfo } from 'src/app/modules/provider-management/constants/provider-management-routes';
import { GetMatchingSchedulesResponse, ParentItemList } from 'src/app/modules/provider-management/interfaces/matching-schedule';
import { IProviderMeetingDetails } from 'src/app/modules/provider-management/interfaces/pa-meeting-details';
import { DashboardPMResponse } from 'src/app/modules/provider-management/interfaces/pm-dashboard.response';
import { ScheduleTimeRequestModel } from 'src/app/modules/provider-management/models/schedule-time-request-model';
import { ProviderManagementService } from 'src/app/modules/provider-management/services/provider-management.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { ScheduleFieldVisibilityConfig, SCHEDULE_FIELD_VISIBILITY } from 'src/assets/config/schedule-field-visibility-config';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { ScheduleMeetingReferenceData } from '../../interfaces/form/schedule-meetiing-reference-data.model';
import { MeetingRecordList } from '../../interfaces/iep-attendes.model';
import { StudentAddress, schoolModel } from '../../interfaces/school-address-interface';
import { User } from '../../models/user';
import { AbstractComponent } from '../abstract-component';
import { ScheduleEvaluatorFormRequestModel } from 'src/app/modules/provider-management/models/schedule-evaluator-form-model';
import { getTimeDiffShort } from '../../functions/time-diff';

@Component({
  selector: 'app-schedule-evaluation-dialogbox',
  templateUrl: './schedule-evaluation-dialogbox.component.html',
  styleUrl: './schedule-evaluation-dialogbox.component.scss',
  standalone: false,
})
export class ScheduleEvaluationDialogboxComponent extends AbstractComponent
  implements OnInit, AfterViewInit {
  public chalkBordUser: SVGIcon = this.customFaIcon(faChalkboardUser);
  public clock: SVGIcon = this.customFaIcon(faClock);
  public repeat: SVGIcon = this.customFaIcon(faRepeat);
  public users: SVGIcon = this.customFaIcon(faUsers);
  public locationDot: SVGIcon = this.customFaIcon(faLocationDot);
  public stairs: SVGIcon = this.customFaIcon(faStairs);
  public car: SVGIcon = this.customFaIcon(faCarSide);
  public indent: SVGIcon = this.customFaIcon(faIndent);
  public xMark: SVGIcon = this.customFaIcon(faCircleXmark);
  public checkMark: SVGIcon = this.customFaIcon(faCircleCheck);
  public defaultItemOccurences: IReferenceData;
  public scheduleDetailsForm: FormGroup;
  protected referenceData: ScheduleMeetingReferenceData = {};
  public disableLocation2: boolean = false;
  public data: ParentItemList = [];
  disableLocationItem: (args: { index: number; dataItem: IReferenceData }) => boolean = () => false;
  @Input() public startDate: Date;
  @Input() public startTime: Date;
  @Input() public endTime: Date;
  @Input() public isEditingSession: boolean = undefined;
  @Input() public isNew: boolean = undefined;
  @Input() public isEdititingMeetingSeries: boolean = false;
  @Input() public selectedMandates: DashboardPMResponse[];
  @Input() public macthedStudentDetails: GetMatchingSchedulesResponse;
  @Input() public meetingSk: string;
  @Input() public displayScheduleTimeButton: boolean;
  @Input() public clickEmptySchedule: boolean;
  @Input() public studentsSelected: boolean;
  @Input() public selecteStudentdMandates: DashboardPMResponse;
  @Input() public schedulerPopupOpen: boolean;
  public today: Date = this.getToday();
  public studMandates: DashboardPMResponse[] = [];
  private user: User;
  @Input() providerManagementInfo: IProviderManagementInfo;
  public providerAgencies: IReferenceData[] = [];
  public evaluatorTitleAgencies: IReferenceData[] = [];
  public fieldVisibilityConfig: ScheduleFieldVisibilityConfig =
    SCHEDULE_FIELD_VISIBILITY;
  public duration: string = '0m';
  readonly providerAgencyType: number = 3;
  @Output() mandateInfo: EventEmitter<GetMatchingSchedulesResponse> =
    new EventEmitter<GetMatchingSchedulesResponse>();
  selectAllevaluatorPhones: IReferenceData[];
  optionalAttendeesList: { name: string; email: string; role: string }[] = [];
  requiredAttendeesList: { name: string; email: string; role: string }[] = [];
  selectedIepManadantes: MeetingRecordList | MeetingRecordList[];
  readonly negativeIndex: number = -1;
  readonly indexNumberOne: number = 1;
  readonly indexNumberTwo: number = 2;
  readonly iconNumberFour: number = 4;
  defaultLocationType: IReferenceData = {
    id: null,
    description: 'Location Type'
  };
  //TODO: Will remove hardcoded once API is integrated. for student/ optionaal and required attendees multiselect tree dropdowns
  public studentData: { id: number, text: string, mandateDescription: string }[] = [
    { id: 1, text: 'John Doe', mandateDescription: 'Math Mandate' },
    { id: 2, text: 'Jane Smith', mandateDescription: 'Science Mandate' },
  ];
  studentList: DashboardPMResponse[];
  editMandateIds: string[];
  readonly daily: number = 2;
  readonly doNotRepeat: number = 1;
  readonly endAfter: number = 1;
  readonly endDate: number = 2;
  readonly everyWeekDay: number = 3;
  readonly monthly: number = 5;
  readonly schoolNumber: number = 1;
  readonly studentNumber: number = 2;
  readonly evaluatorNameType: number = 3;
  readonly maxMinutesInputLength: number = 4;
  public scheduleLocationsRefernceData: IReferenceData[];
  public showRecordTime: boolean;
  public showAuthorizedTraining: boolean;
  meetingDetails: IProviderMeetingDetails;
  requiredLookupData: { id: string; text: string; isParent: boolean; items?: { id: string; text: string; isParent: boolean }[] }[] = [];
  optionalLookupData: { id: string; text: string; isParent: boolean; items?: { id: string; text: string; isParent: boolean }[] }[] = [];
  constructor(
    public referenceStore: ReferenceStore,
    private formBuilder: FormBuilder,
    private actiavtedRoute: ActivatedRoute,
    private providerManagementService: ProviderManagementService,
    private authStore: AuthStore,
    public cdRef: ChangeDetectorRef,
    private laodingService: LoadingService
  ) {
    super();
    this.initializeForm();
  }
  ngAfterViewInit(): void {
    const form: FormGroup = this.scheduleDetailsForm;
    form.get('studentName')?.valueChanges.pipe(
      startWith(form.get('studentName')?.value)).subscribe((mandates: any) => {

        this.disableLocation2 = mandates?.length > this.indexNumberOne;

        if (this.disableLocation2) {
          this.disableLocationItem = (args: { index: number; dataItem: IReferenceData }): boolean =>

            args?.dataItem?.id === this.indexNumberTwo;
          if (this.scheduleDetailsForm.get('locationType')?.value === null) {
            this.disableLocationItem = (args: { index: number; dataItem: IReferenceData }): boolean => args?.dataItem?.id === null;

          }

        } else if (this.scheduleDetailsForm.get('locationType')?.value === null) {
          this.disableLocationItem = (args: { index: number; dataItem: IReferenceData }): boolean => args?.dataItem?.id === null;

        } else {
          this.disableLocationItem = (): boolean => false;
        }

      });
    form.get('locationType').valueChanges.pipe(
      startWith(form.get('locationType')?.value)).subscribe((locationType: any) => {
        if (locationType?.id === this.schoolNumber || locationType?.id === this.studentNumber) {

          const payload: getStudentSchoolAddressModel = {
            studentSks: [this.selecteStudentdMandates?.studentSk],
            locationType: locationType?.id,
          }

          this.laodingService.show();
          this.providerManagementService.getStudentSchoolAddress(payload).pipe(finalize(() => {
            this.laodingService?.hide();
          })).subscribe((data: any) => {
            if (locationType?.id === this.schoolNumber) {
              const schooloeAddress: StudentAddress = data?.enrollment?.address;
              if (schooloeAddress?.streetAddress1 !== null
              ) {

                const {
                  adminSchoolDBN,
                  adminSchoolName
                }: StudentAddress = data?.enrollment ?? {};

                const {
                  streetAddress1,
                  city,
                  stateName,
                  zip
                }: StudentAddress = schooloeAddress ?? {};

                // Build address parts safely
                const parts: string[] = [];

                // DBN + [SchoolName] block (only if real data exists)
                if (adminSchoolDBN || adminSchoolName) {
                  const dbnBlock: string =
                    (adminSchoolDBN ? `[${adminSchoolDBN}] ` : '') +  // brackets for DBN
                    (adminSchoolName ?? '');                          // no brackets for name

                  if (dbnBlock.trim().length > 0) {
                    parts.push(dbnBlock.trim());
                  }
                }

                // Address fields (only push if not null)
                if (streetAddress1) parts.push(streetAddress1);
                if (city) parts.push(city);
                if (stateName) parts.push(stateName);
                if (zip) parts.push(zip);

                // If no parts → do not bind
                if (parts.length > 0) {
                  this.scheduleDetailsForm.get('location')?.setValue(parts.join(', '));
                } else {
                  // this.scheduleDetailsForm.get('location')?.reset();
                  Object.values(this.scheduleDetailsForm?.controls).forEach((c: AbstractControl) => {
                    c.markAsTouched();
                    c.markAsDirty();
                    c.updateValueAndValidity({ emitEvent: false });
                  });
                }

              }
            }
            else if (locationType?.id === this.studentNumber) {
              const studentAddress: StudentAddress = data?.studentAddress;
              if (studentAddress?.streetAddress1 !== null) {
                const {
                  schoolDBN,
                  schoolName
                }: schoolModel = data ?? {};

                const {
                  streetAddress1,
                  city,
                  stateName,
                  zip
                }: StudentAddress = studentAddress ?? {};

                // Check if ANY field exists
                const hasAnyValue: boolean =
                  !!schoolDBN ||
                  !!schoolName ||
                  !!streetAddress1 ||
                  !!city ||
                  !!stateName ||
                  !!zip;

                if (hasAnyValue) {
                  const parts: string[] = [];

                  // DBN + [SchoolName] block
                  // if (schoolDBN || schoolName) {
                  //   const dbnBlock: string =
                  //     (schoolDBN ? `[${schoolDBN}]` : '') +
                  //     (schoolName ?? '');

                  //   if (dbnBlock.trim().length > 0) {
                  //     parts.push(dbnBlock);
                  //   }
                  // }
                  // Other address fields
                  if (streetAddress1) parts.push(streetAddress1);
                  if (city) parts.push(city);
                  if (stateName) parts.push(stateName);
                  if (zip) parts.push(zip);

                  // Final formatted address
                  const address: string = parts.length > 0 ? parts.join(', ') : null;

                  this.scheduleDetailsForm.get('location')?.setValue(address);
                } else {

                  // this.scheduleDetailsForm.get('location')?.reset();
                  Object.values(this.scheduleDetailsForm?.controls).forEach((c: AbstractControl) => {
                    c.markAsTouched();
                    c.markAsDirty();
                    c.updateValueAndValidity({ emitEvent: false });
                  });
                }
              }
            }
            this.cdRef.markForCheck();
            this.laodingService.hide();
          })

        } else {
          // this.scheduleDetailsForm.get('location')?.reset();
          Object.values(this.scheduleDetailsForm?.controls).forEach((c: AbstractControl) => {
            c.markAsTouched();
            c.markAsDirty();
            c.updateValueAndValidity({ emitEvent: false });
          });

        }

        if (locationType?.id === this.providerAgencyType) {


          this.laodingService.show();
          this.providerManagementService.getProviderAgencyAddress(this.user?.providerSk).subscribe((data: any) => {
            if (data) {
              this.scheduleDetailsForm.get('location')?.setValue(data);
            }
            this.laodingService.hide();
          })
        }
        else {
          if (locationType) {
            // this.scheduleDetailsForm.get('location')?.reset();
            Object.values(this.scheduleDetailsForm?.controls).forEach((c: AbstractControl) => {
              c.markAsTouched();
              c.markAsDirty();
              c.updateValueAndValidity({ emitEvent: false });
            });

          }

        }
        if (locationType?.value === 'Other') {
          this.scheduleDetailsForm.get('location')?.reset();
        }
        this.cdRef.markForCheck();
      })
    this.initWatches();
    form.markAllAsTouched();
  }



  ngOnInit(): void {
    this.laodingService.show();
    this.authStore.UserInfo$.pipe(filter((user: User) => !!user)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;
      }
    );
    if (!this.isNew) {
      this.laodingService.show();
      this.patchSchedilerMeetingDetails();
    } else {
      this.providerManagementService.bindSelectedScheduleDetails$.subscribe(data => {
        if (data) {
          this.scheduleDetailsForm.patchValue({
            ...data,
            location: data?.location
          })
        }
      })
      this.providerManagementService.bindScheduleDetails$.subscribe((details: any) => {
        if (details?.isSelected) {
          this.scheduleDetailsForm.patchValue({
            startDate: details?.start,
            startTime: details?.start,
            endTime: details.end
          })
        }
      })
    }
    this.initWatches();
    this.patchEmptySchedule();
  }
  patchEmptySchedule(): void {
    if (this.clickEmptySchedule) {
      const scheduleTimeFormModel: ScheduleTimeRequestModel =
        new ScheduleTimeRequestModel({
          startDate: this.startDate,
          startTime: this.startTime,
          endTime: this.endTime,
          endByDate: this.endTime,

        });
      this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);
    } else if (this.schedulerPopupOpen) {
      this.scheduleDetailsForm.get('startDate').setValue(this.startDate)
      this.scheduleDetailsForm.get('startTime').setValue(this.startTime)
      this.scheduleDetailsForm.get('endTime').setValue(this.endTime)
      this.scheduleDetailsForm.get('endByDate').setValue(this.endTime)
    }
  }




  initWatches(): void {
    // Note: EvaluationAttendeesRequest instantiation was intended for future use
    this.providerManagementService
      .getAllEvaluationAttendess(this.selecteStudentdMandates?.physicalDBN)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: any) => {
          if (res?.attendeesByRole.length > 0) {
            this.requiredLookupData = this.buildLookup(res.attendeesByRole);
          }

        },
      });

    this.referenceStore.evaluationType$.subscribe((data: IReferenceData[]) => {
      this.referenceData.evaluationType = data;
      this.scheduleDetailsForm.get('evaluationType').disable();
      this.scheduleDetailsForm.get('evaluatorName').disable();
      this.scheduleDetailsForm.get('evaluatorTitle').disable();
      this.scheduleDetailsForm.get('evaluatorPhone').disable();
      this.scheduleDetailsForm.get('evaluatorEmail').disable();
      if (this.selecteStudentdMandates) {
        this.scheduleDetailsForm.get('evaluationType').setValue({ id: this.selecteStudentdMandates?.evaluationTypeId });
        this.providerManagementService.getProviderDetails(this.selecteStudentdMandates?.providerSk).subscribe((details: any) => {
          this.scheduleDetailsForm.get('evaluatorTitle').setValue(details?.title ? details?.title : null);
          this.scheduleDetailsForm.get('evaluatorPhone').setValue(details?.phone ? details?.phone : null);

        })
      }
    });
    if (this.selecteStudentdMandates) {
      this.scheduleDetailsForm.get('studentName').setValue([this.selecteStudentdMandates]);
      this.scheduleDetailsForm.get('studentName').disable();
      // this.laodingService.hide();
    }
    if (this.isNew) {
      this.scheduleDetailsForm.get('evaluatorName').setValue(this.user?.name);
      this.scheduleDetailsForm.get('evaluatorEmail').setValue(this.user?.email);
      // this.laodingService.hide();
    }
    const startTimeControl: FormControl = this.scheduleDetailsForm?.get(
      'startTime'
    ) as FormControl;
    const endTimeControl: FormControl = this.scheduleDetailsForm?.get(
      'endTime'
    ) as FormControl;
    // this.scheduleDetailsForm.get('studentName').setValue();
    combineLatest([
      startTimeControl?.valueChanges.pipe(startWith(startTimeControl?.value)),
      endTimeControl?.valueChanges.pipe(startWith(endTimeControl?.value)),
    ]).subscribe(([start, end]: [Date | string, Date | string]) => {
      if (start && end) {
        const duration: string = getTimeDiffShort(start, end);
        this.duration = duration;
      }
    });
    // if (this.isNew) {
    //   this.laodingService?.hide();
    // }

  }


  patchSchedilerMeetingDetails(): void {
    // this.laodingService.show();
    this.providerManagementService
      .getEvaluatorMeetingDetails(this.meetingSk)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: IProviderMeetingDetails) => {

          if (res) {
            this.editMandateIds = res?.Mandates;
            const formJSONData: string = res.MeetingJson;
            const parsedData: IProviderMeetingDetails = JSON.parse(formJSONData);
            this.meetingDetails = parsedData;
            const formJson: ScheduleEvaluatorFormRequestModel = JSON.parse((this.meetingDetails as any)?.formJson);
            this.selecteStudentdMandates = formJson?.students;


            this.providerManagementService.bindScheduleDetails$.subscribe((details: any) => {
              if (details) {

                const scheduleTimeFormModel: ScheduleTimeRequestModel =
                  new ScheduleTimeRequestModel({
                    ...formJson,
                    dragedStartDate: details.start,
                    dragedStartTime: details.start,
                    dragedEndTime: details.end,
                    parentSK: parsedData?.ParentSk,
                    studentSk: parsedData?.StudentSk,
                    nycId: parsedData?.NYCID,
                    meetingSk: this.meetingSk,

                  });
                this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);

              } else {
                this.providerManagementService.bindSelectedScheduleDetails$.subscribe(data => {
                  if (data) {
                    this.scheduleDetailsForm.patchValue({
                      ...data,
                      location: data?.location
                    })
                  } else {
                    const scheduleTimeFormModel: ScheduleTimeRequestModel =
                      new ScheduleTimeRequestModel({
                        ...formJson,
                        dragedStartDate: this.startDate,
                        dragedStartTime: this.startTime,
                        dragedEndTime: this.endTime,
                        parentSK: parsedData?.ParentSk,
                        studentSk: parsedData?.StudentSk,
                        nycId: parsedData?.NYCID,
                        meetingSk: this.meetingSk,

                      });

                    this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);
                  }
                })

              }
            });
          }
          this.laodingService.hide();

        }
      });


  }
  public getToday(): Date {
    const d: Date = new Date();
    d.setHours(0, 0, 0, 0); // IMPORTANT: remove time
    return d;
  }

  get startTimes(): Date | null {
    return this.scheduleDetailsForm.get('startTime')?.value || null;
  }

  get endTimes(): Date | null {
    return this.scheduleDetailsForm.get('endTime')?.value || null;
  }


  initializeForm(): FormGroup {
    return (this.scheduleDetailsForm = this.formBuilder.group({
      evaluationType: new FormControl(null, Validators.required),
      evaluatorName: new FormControl(null),
      evaluatorTitle: new FormControl(null),
      evaluatorPhone: new FormControl(null),
      evaluatorEmail: new FormControl(null),
      startDate: new FormControl(null, Validators.required),
      startTime: new FormControl(null, Validators.required),
      endTime: new FormControl(null, Validators.required),
      studentName: new FormControl([]),
      locationType: new FormControl(null),
      location: new FormControl(null),
      floorRoom: new FormControl(null),
      teamsMeeting: new FormControl(false),
      minutes: new FormControl(null),
      additionalInfo: new FormControl(null),
      students: new FormControl([]),
      requiredAttendees: new FormControl([]),
      optionalAttendees: new FormControl([]),
      parentSK: new FormControl(null),
      studentSk: new FormControl(null),
      nycId: new FormControl(null),
      meetingSk: new FormControl(null),
    }));
  }
  public buildLookup(source: { role: string; staff: { firstName: string; lastName: string }[] }[]): { id: string; text: string; isParent: boolean; items?: { id: string; text: string; isParent: boolean }[] }[] {
    return source.map((group: { role: string; staff: { firstName: string; lastName: string }[] }, gIndex: number) => ({
      id: `group-${gIndex}`,
      text: group.role,
      isParent: true,
      items: group.staff.map((att: { firstName: string; lastName: string }, aIndex: number) => ({
        id: `item-${gIndex}-${aIndex}`,
        text: `${att.firstName} ${att.lastName}`,
        isParent: false
      }))
    }));
  }
  onAttendeesChange(values: { isParent?: boolean }[]): void {
    if (!Array.isArray(values)) {
      return;
    }

    // keep ONLY child items
    const onlyChildren: { isParent?: boolean }[] = values.filter((item: { isParent?: boolean }) => !item.isParent);

    this.scheduleDetailsForm
      .get('requiredAttendees')
      ?.setValue(onlyChildren, { emitEvent: false });
  }
  onOptionalAttendeesChange(values: { isParent?: boolean }[]): void {
    if (!Array.isArray(values)) {
      return;
    }

    // keep ONLY child items
    const onlyChildren: { isParent?: boolean }[] = values.filter((item: { isParent?: boolean }) => !item.isParent);

    this.scheduleDetailsForm
      .get('optionalAttendees')
      ?.setValue(onlyChildren, { emitEvent: false });
  }
  selectedWeekChipChange(e: number[]): void {
    // Map chip indices (0-6) to WeekDays enum values (1-7)
    const weekDayValues: number[] = e.map((i: number) => i + this.indexNumberOne);
    this.scheduleDetailsForm.get('weekDayChip')?.setValue(weekDayValues);
  }

  override afterOnDestroy(): void {
    //Hndle Cleanup
  }
  customFaIcon(icon: IconDefinition): SVGIcon {
    // FontAwesome icon structure: [width, height, horizontalAlign, verticalAlign, pathData]
    if (!icon || !icon.icon) {
      return {
        name: 'unknown',
        content: '<path d="" />',
        viewBox: '0 0 512 512',
      };
    }

    const defaultViewBoxSize: number = 512;
    const heightIndex: number = 1;
    const pathIndex: number = 4;

    const width: number = (icon.icon[0] as number) || defaultViewBoxSize;
    const height: number = (icon.icon[heightIndex] as number) || defaultViewBoxSize;
    const pathData: string = (icon.icon[pathIndex] as string) || '';

    return {
      name: icon.iconName || 'icon',
      content: `<path d="${pathData}" />`,
      viewBox: `0 0 ${width} ${height}`,
    };
  }

  /**
   * Return validation status and message for a given logical field name.
   * Looks for validation info returned from matching service (`macthedStudentDetails.validation`)
   * and falls back to reactive form control validity when available.
   */
  public getFieldValidation(field: string): { status: 'ok' | 'error' | null; message?: string } {
    try {
      const remoteValidation: Record<string, { isValid?: boolean; message?: string } | string> = (this.macthedStudentDetails as { validation?: Record<string, { isValid?: boolean; message?: string } | string> })?.validation;
      if (remoteValidation && remoteValidation[field]) {
        const entry: { isValid?: boolean; message?: string } | string = remoteValidation[field];
        // Expecting shape like: { isValid: boolean, message: string }
        if (typeof entry !== 'string' && typeof entry.isValid === 'boolean') {
          return { status: entry.isValid ? 'ok' : 'error', message: entry.message };
        }
        // If entry is a simple string message, treat as error
        if (typeof entry === 'string') {
          return { status: 'error', message: entry };
        }
      }

      // Fallback to form control validity
      const control: AbstractControl = this.scheduleDetailsForm?.get(field as string);
      if (control) {
        if (control.valid) return { status: 'ok' };
        // only show error if user interacted or value exists
        if (control.invalid && (control.touched || control.dirty || control.value)) {
          return { status: 'error', message: 'Invalid value' };
        }
      }
    } catch {
      // ignore and return null status
    }
    return { status: null };
  }

  // getReferenceData(): void {
  //   combineLatest([
  //     this.referenceStore.occurences$,
  //     this.referenceStore.evaluationType$,
  //     this.referenceStore.evaluationType$,
  //   ])
  //     .pipe(takeUntil(this.componentDestroyed))
  //     .subscribe(
  //       ([occurences, evaluationType, evaluationTye]: [IReferenceData[], IReferenceData[], IReferenceData[]]) => {
  //         this.referenceData.occurences = occurences || [];
  //         this.referenceData.evaluationType =
  //           this.displayScheduleTimeButton
  //             ? evaluationType.filter((m: IReferenceData) => m.id === 1)
  //             : evaluationType.filter((m: IReferenceData) => m.id !== 1);
  //         this.referenceData.evaluationType = evaluationTye || [];
  //         this.initWatches();
  //       }
  //     );
  // }

  //Preventing open state of student/ mandates multiselect
  onOpen(event: PreventableEvent): void {
    event.preventDefault();
  }

  public itemDisabled(itemArgs: { index: number }): boolean {
    return itemArgs.index === this.negativeIndex;
  }
  onMinutesInput(event: Event): void {
    const input: HTMLInputElement = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');
    if (input.value.length > this.maxMinutesInputLength) {
      input.value = input.value.slice(0, this.maxMinutesInputLength);
    }
  }

}
